// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__emfrY","fullView":"styles_fullView__3pDYf"};